import { render, staticRenderFns } from "./Share-File.vue?vue&type=template&id=170ae370&scoped=true&"
import script from "./Share-File.vue?vue&type=script&lang=js&"
export * from "./Share-File.vue?vue&type=script&lang=js&"
import style0 from "./Share-File.vue?vue&type=style&index=0&id=170ae370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170ae370",
  null
  
)

export default component.exports